export default "__VITE_ASSET__BJFnfP_G__"